import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function GraphismeReset() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) { setError("Les deux mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      await api.post("/graphisme/auth/reset", { token, password: pw });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Ce lien est invalide ou a expiré");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-6" data-testid="greset-page">
      <div className="w-full max-w-sm">
        <div className="bg-white border border-neutral-200 rounded-2xl shadow-sm p-8">
          <div className="flex flex-col items-center text-center mb-6">
            <img src="/logo-dga.png" alt="DGA" className="w-14 h-14 rounded-xl object-cover mb-4" />
            <h1 className="font-heading text-xl font-bold">Choisissez votre nouveau mot de passe</h1>
          </div>
          {done ? (
            <div className="space-y-4 text-center">
              <p className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg p-3" data-testid="greset-success">
                Votre mot de passe a été enregistré. Vous pouvez maintenant vous connecter.
              </p>
              <Button onClick={() => navigate("/connexion")} className="w-full bg-neutral-900 hover:bg-neutral-800 text-white" data-testid="greset-goto-login">
                Se connecter
              </Button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <div>
                <Label>Nouveau mot de passe</Label>
                <Input data-testid="greset-password" type="password" className="mt-1.5" value={pw}
                  onChange={(e) => setPw(e.target.value)} required minLength={8} autoComplete="new-password" />
                <p className="text-[11px] text-neutral-400 mt-1">8 caractères minimum.</p>
              </div>
              <div>
                <Label>Confirmer le mot de passe</Label>
                <Input data-testid="greset-password2" type="password" className="mt-1.5" value={pw2}
                  onChange={(e) => setPw2(e.target.value)} required minLength={8} autoComplete="new-password" />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="greset-error">{error}</p>}
              <Button data-testid="greset-submit" type="submit" disabled={loading || pw.length < 8}
                className="w-full bg-neutral-900 hover:bg-neutral-800 text-white h-10">
                {loading ? "Enregistrement…" : "Enregistrer mon mot de passe"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
